// extracted by mini-css-extract-plugin
export default {"base":"style_base__J1jp+"};